import User from '@/utils/models/User'
let roles = User.roles();
export const navigationRoutes = {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'survey',
      displayName: 'Dashboard',
      meta: {
        iconClass: 'dashboard',        
      },      
    }, 
    {
      name: 'dashboard',
      displayName: 'Presentation',
      meta: {
        iconClass: 'pie_chart',        
      },      
      visible : roles.includes('sys_admin')||roles.includes('trial'),
    },        
    {
      name: 'survey/customer',
      displayName: 'Customer View',
      meta: {
        iconClass: 'account_circle',        
      },      
      visible : roles.includes('sys_admin')||roles.includes('trial'),
    },
    {
      name: 'laporan',
      displayName: 'Laporan',
      meta: {
        iconClass: 'library_books',
      },   
      visible : roles.includes('sys_admin')||roles.includes('surveyor')||roles.includes('trial'),   
      children: [
        {
          name: 'report/surveyor',
          displayName: 'Surveyor',
          visible : roles.includes('sys_admin')||roles.includes('trial'),
        },
        {
          name: 'report/responden',
          displayName: 'Responden',
        },       
      ],
    },    
    {
      name: 'admin',
      displayName: 'Admin',
      meta: {
        iconClass: 'account_box',
      },
      visible : roles.includes('sys_admin'),
      children: [       
        {
          name: 'admin/users',
          displayName: 'User',
        },{
          name: 'admin/rbac',
          displayName: 'Access Control',
        },
      ],
    },   
    {
      name: 'master',
      displayName: 'Master Data',
      meta: {
        iconClass: 'dns',
      },
      visible : roles.includes('sys_admin')||roles.includes('trial'),
      children: [                
        {
          name: 'master/quetionnaire',
          displayName: 'Quetionnaire',
          meta: {
            iconClass: 'assignment',
          },
          visible : roles.includes('sys_admin')
        },
        {
          name: 'master/kompetisi',
          displayName: 'Kompetisi',
          meta: {
            iconClass: 'event',
          },
        },
        {
          name: 'master/partai',
          displayName: 'Partai',
          meta: {
            iconClass: 'brightness_medium',
          },
        },
        {
          name: 'master/calon',
          displayName: 'Calon',
          meta: {
            iconClass: 'person',
          },
        },
        {
          name: 'master/nodes',
          displayName: 'Nodes',
          meta: {
            iconClass: 'streetview',
          },
        }, 
        {
          name: 'master/dapil',
          displayName: 'Dapil',
          meta: {
            iconClass: 'how_to_vote',
          },
        },        
      ],
    },   
  ],
}
